import i18n from './i18n';

export const changeLanguage = (locale) => {
    i18n.changeLanguage(locale);
    localStorage.setItem('locale', locale);
    document.documentElement.lang = locale;
};



// WEBPACK FOOTER //
// ./resources/assets/js/locales/LocaleService.js